module.exports = __webpack_public_path__ + "static/homepage-desktop-dm-bbd9a1dd697f81981c3d2d31d90529a5.jpg";